<script>
	import { createEventDispatcher } from 'svelte';
	import Icon from '../icons/Icon.svelte';

	const dispatch = createEventDispatcher();

	export let show = true;
	export let activeChat = null;
	export let extractedOrderFromChat = null;

	export let getInitials = (name) => {
		if (!name) return "CL";
		const clean = name.replace(/[^\w\s]/gi, '').trim();
		const parts = clean.split(/\s+/).filter(Boolean);
		if (parts.length === 0) return "CL";
		if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
		return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
	};

	export let formatPhoneNumber = (phone) => {
		if (!phone) return "";
		const clean = phone.replace(/\D/g, "");
		if (clean.length === 13 && clean.startsWith("55")) {
			return `+55 (${clean.slice(2, 4)}) ${clean.slice(4, 9)}-${clean.slice(9)}`;
		}
		if (clean.length === 12 && clean.startsWith("55")) {
			return `+55 (${clean.slice(2, 4)}) ${clean.slice(4, 8)}-${clean.slice(8)}`;
		}
		if (clean.length === 11) {
			return `(${clean.slice(0, 2)}) ${clean.slice(2, 7)}-${clean.slice(7)}`;
		}
		if (clean.length === 10) {
			return `(${clean.slice(0, 2)}) ${clean.slice(2, 6)}-${clean.slice(6)}`;
		}
		return phone;
	};

	function handleClose() {
		dispatch('close');
	}

	function handleToggleBot() {
		dispatch('toggleBot');
	}

	function handleApplyMacro(type) {
		dispatch('applyMacro', type);
	}
</script>

{#if show && activeChat}
	<aside class="customer-dossier-drawer" aria-label="Dossiê do Cliente">
		<div class="drawer-header">
			<h4>Dossiê do Cliente</h4>
			<button class="drawer-close-btn" on:click={handleClose} aria-label="Fechar"><Icon name="x" size={16} /></button>
		</div>

		<div class="drawer-body">
			<!-- Perfil Rápido -->
			<div class="drawer-profile-card">
				<div class="profile-avatar" class:initials-avatar={!activeChat.avatarUrl}>
					{#if activeChat.avatarUrl}
						<img src="{activeChat.avatarUrl}" alt="{activeChat.name}" class="avatar-photo-img" on:error={() => { activeChat.avatarUrl = null; }} />
					{:else}
						{getInitials(activeChat.name)}
					{/if}
				</div>
				<strong class="profile-name">{activeChat.name}</strong>
				<span class="profile-phone">{formatPhoneNumber(activeChat.phone)}</span>
			</div>

			<!-- Status de Atendimento -->
			<div class="drawer-card">
				<span class="drawer-card-title">Status do Atendimento</span>
				<div class="drawer-status-badge {activeChat.botActive && !activeChat.needsHuman ? 'bot' : 'human'}">
					{#if activeChat.needsHuman}
						<span><Icon name="alert-triangle" size={13} /> Aguardando Atendente Humano</span>
					{:else if !activeChat.botActive}
						<span><Icon name="user" size={13} /> Em Atendimento Humano</span>
					{:else}
						<span><Icon name="bot" size={13} /> IA Respondendo em Tempo Real</span>
					{/if}
				</div>
			</div>

			<!-- Pedido Detectado na Conversa -->
			<div class="drawer-card">
				<span class="drawer-card-title">Pedido Detectado no Chat</span>
				{#if extractedOrderFromChat}
					<div class="detected-order-box">
						<div class="order-box-top">
							<strong>Pedido #{extractedOrderFromChat.orderNumber || 'Novo'}</strong>
							{#if extractedOrderFromChat.total}
								<span class="order-total-badge">R$ {extractedOrderFromChat.total}</span>
							{/if}
						</div>
						{#if extractedOrderFromChat.paymentMethod}
							<div class="order-meta-line">
								<span>Pagamento:</span>
								<strong>{extractedOrderFromChat.paymentMethod}</strong>
							</div>
						{/if}
						<div class="order-detected-msg">
							<small>Identificado automaticamente pela IA na conversa.</small>
						</div>
					</div>
				{:else}
					<div class="no-order-box">
						<p>Nenhum pedido finalizado detectado nesta conversa até o momento.</p>
					</div>
				{/if}
			</div>

			<!-- Ações Rápidas do Atendente -->
			<div class="drawer-card">
				<span class="drawer-card-title">Ações do Atendente</span>
				<div class="drawer-actions-stack">
					<button
						class="btn-drawer-action"
						on:click={handleToggleBot}
					>
						<Icon name={activeChat.botActive ? "pause" : "play"} size={14} />
						<span>{activeChat.botActive ? 'Pausar IA deste Cliente' : 'Retomar IA para este Cliente'}</span>
					</button>
					<button
						class="btn-drawer-action"
						on:click={() => handleApplyMacro('menu')}
					>
						<Icon name="book-open" size={14} />
						<span>Enviar Link do Cardápio</span>
					</button>
					<button
						class="btn-drawer-action"
						on:click={() => handleApplyMacro('pix')}
					>
						<Icon name="key" size={14} />
						<span>Enviar Chave PIX</span>
					</button>
				</div>
			</div>
		</div>
	</aside>
{/if}

<style>
/* DOSSIÊ DO CLIENTE (PAINEL DIREITO) */
	.customer-dossier-drawer {
		background: var(--neutral-surface, #FFFFFF);
		border-left: 1px solid var(--neutral-border, #E2E8F0);
		display: flex;
		flex-direction: column;
		height: 100%;
		overflow-y: auto;
	}

	.drawer-header {
		padding: 14px 18px;
		border-bottom: 1px solid var(--neutral-border, #E2E8F0);
		display: flex;
		justify-content: space-between;
		align-items: center;
	}

	.drawer-header h4 {
		margin: 0;
		font-size: 14px;
		font-weight: 800;
		color: var(--text-primary, #0F172A);
	}

	.drawer-close-btn {
		background: transparent;
		border: none;
		color: var(--text-secondary, #64748B);
		cursor: pointer;
		display: flex;
		align-items: center;
		padding: 2px;
	}

	.drawer-body {
		padding: 16px;
		display: flex;
		flex-direction: column;
		gap: 14px;
	}

	.drawer-profile-card {
		display: flex;
		flex-direction: column;
		align-items: center;
		text-align: center;
		padding: 16px 12px;
		background: var(--neutral-surface-hover, #F8FAFC);
		border-radius: var(--radius-md, 12px);
		border: 1px solid var(--neutral-border, #E2E8F0);
		gap: 4px;
	}

	.profile-avatar {
		width: 52px;
		height: 52px;
		border-radius: 50%;
		font-size: 18px;
		margin-bottom: 4px;
	}

	.profile-name {
		font-size: 14px;
		color: var(--text-primary, #0F172A);
	}

	.profile-phone {
		font-size: 12px;
		color: var(--text-secondary, #64748B);
	}

	.drawer-card {
		background: #FFFFFF;
		border: 1px solid var(--neutral-border, #E2E8F0);
		border-radius: var(--radius-md, 12px);
		padding: 14px;
		display: flex;
		flex-direction: column;
		gap: 8px;
	}

	.drawer-card-title {
		font-size: 11px;
		font-weight: 700;
		color: var(--text-secondary, #64748B);
		text-transform: uppercase;
		letter-spacing: 0.5px;
	}

	.drawer-status-badge {
		padding: 8px 10px;
		border-radius: 8px;
		font-size: 12px;
		font-weight: 700;
	}

	.drawer-status-badge.bot {
		background: #DCFCE7;
		color: #16A34A;
	}

	.drawer-status-badge.human {
		background: #EFF6FF;
		color: #2563EB;
	}

	.detected-order-box {
		background: var(--brand-primary-soft, #FFF7ED);
		border: 1px solid rgba(255, 106, 0, 0.2);
		border-radius: 8px;
		padding: 10px 12px;
		display: flex;
		flex-direction: column;
		gap: 4px;
	}

	.order-box-top {
		display: flex;
		justify-content: space-between;
		align-items: center;
		font-size: 13px;
	}

	.order-total-badge {
		background: var(--brand-primary, #FF6A00);
		color: #FFFFFF;
		padding: 2px 6px;
		border-radius: 4px;
		font-weight: 800;
		font-size: 11.5px;
	}

	.order-meta-line {
		display: flex;
		justify-content: space-between;
		font-size: 12px;
		color: var(--text-secondary, #64748B);
	}

	.order-detected-msg small {
		font-size: 10.5px;
		color: var(--text-muted, #94A3B8);
	}

	.no-order-box p {
		margin: 0;
		font-size: 12px;
		color: var(--text-muted, #94A3B8);
	}

	.drawer-actions-stack {
		display: flex;
		flex-direction: column;
		gap: 6px;
	}

	.btn-drawer-action {
		display: inline-flex;
		align-items: center;
		gap: 8px;
		background: var(--neutral-surface-hover, #F8FAFC);
		border: 1px solid var(--neutral-border, #CBD5E1);
		padding: 8px 12px;
		border-radius: 8px;
		font-size: 12px;
		font-weight: 600;
		color: var(--text-secondary, #475569);
		cursor: pointer;
		transition: all 0.15s ease;
		text-align: left;
	}

	.btn-drawer-action:hover {
		background: #E2E8F0;
		color: var(--text-primary, #0F172A);
	}
	.initials-avatar {
		width: 52px;
		height: 52px;
		border-radius: 50%;
		background: #E2E8F0;
		color: #334155;
		font-size: 16px;
		font-weight: 800;
		display: flex;
		align-items: center;
		justify-content: center;
		position: relative;
		flex-shrink: 0;
	}

	.avatar-photo-img {
		width: 100%;
		height: 100%;
		border-radius: 50%;
		object-fit: cover;
		display: block;
		background: #E2E8F0;
		border: 1px solid rgba(0, 0, 0, 0.08);
	}


	@media (max-width: 768px) {
		.customer-dossier-drawer {
			position: absolute;
			right: 0;
			top: 0;
			width: 290px;
			z-index: 10;
			box-shadow: -4px 0 16px rgba(0, 0, 0, 0.1);
		}
	}
</style>
